import { postJson, setFieldError, EMAIL_REGEX } from "./request"

const OPEN_DELAY_MS = 2000
const DISMISS_DAYS = 30

// Discount newsletter popup. The server only renders it when the admin
// setting is on and the visitor has no "newsletter=true" cookie.
export default function initNewsletter(dialog) {
  if (typeof dialog.showModal !== "function") return

  const form = dialog.querySelector("form")
  const input = form.querySelector('input[type="email"]')
  const button = form.querySelector('button[type="submit"]')
  const steps = dialog.querySelectorAll("[data-step]")
  // After a signup the server sets its own long-lived cookie; don't shorten it.
  let subscribed = false

  const remember = () => {
    if (subscribed) return
    const expires = new Date(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000).toUTCString()
    document.cookie = `newsletter=true; expires=${expires}; path=/`
  }

  dialog.querySelectorAll("[data-modal-close]").forEach((close) => close.addEventListener("click", () => dialog.close()))
  dialog.addEventListener("close", remember)
  // Clicking the backdrop closes the dialog.
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close()
  })

  form.addEventListener("submit", (event) => {
    event.preventDefault()
    const email = input.value.trim()
    let message = ""
    if (!email) message = "Privaloma"
    else if (email.length > 50) message = "Daugiausia 50 simbolių"
    else if (!EMAIL_REGEX.test(email)) message = "Neteisingas el. pašto adresas"
    setFieldError(input, message)
    if (message) return input.focus()

    button.disabled = true
    postJson("/new_newsletter", { newsletter: { email } })
      .then(() => {
        subscribed = true
        steps.forEach((step) => (step.hidden = step.dataset.step !== "done"))
        dialog.querySelector('[data-step="done"] button').focus()
      })
      .catch(({ body }) => {
        const taken = body && body.errors && body.errors.newsletter && String(body.errors.newsletter.email).includes("jau užimtas")
        setFieldError(input, taken ? "Toks el. pašto adresas jau egzistuoja" : "Nepavyko užregistruoti, bandykite dar kartą")
        input.focus()
      })
      .finally(() => {
        button.disabled = false
      })
  })

  setTimeout(() => dialog.showModal(), OPEN_DELAY_MS)
}
